/**
 * @constant {{
 * MAILCHIMP: String,
 * SENDINBLUE: String,
 * ACTIVECAMPAIGN: String,
 * KLAVIYO: String,
 * PIPEDRIVE_CAMPAIGNS: String,
 * DRIP: String,
 * MAILERLITE: String,
 * HUBSPOT: String,
 * LEMLIST: String,
 * KLENTY: String,
 * APOLLO: String,
 * OUTREACH: String,
 * CONSTANT_CONTACT: String,
 * SENDGRID: String,
 * OUTPLAY: String,
 * ORTTO: String,
 * CONVERTKIT: String,
 * REPLY_IO: String,
 * GETRESPONSE: String
 * }}
 */
const EmailTools = Object.freeze({
	MAILCHIMP: 'mailchimp',
	SENDINBLUE: 'brevo',
	ACTIVECAMPAIGN: 'activecampaign',
	KLAVIYO: 'klaviyo',
	PIPEDRIVE_CAMPAIGNS: 'pipedrive_campaigns',
	DRIP: 'drip',
	MAILERLITE: 'mailerlite',
	HUBSPOT: 'hubspot',
	LEMLIST: 'lemlist',
	KLENTY: 'klenty',
	APOLLO: 'apollo',
	OUTREACH: 'outreach',
	CONSTANT_CONTACT: 'constantcontact',
	SENDGRID: 'sendgrid',
	OUTPLAY: 'outplay',
	ORTTO: 'ortto',
	CONVERTKIT: 'convertkit',
	REPLY_IO: 'reply_io',
	GETRESPONSE: 'getresponse'
});

/**
 * @constant {{
 * MAILCHIMP: String,
 * SENDINBLUE: String,
 * ACTIVECAMPAIGN: String,
 * KLAVIYO: String,
 * PIPEDRIVE_CAMPAIGNS: String,
 * DRIP: String,
 * MAILERLITE: String,
 * HUBSPOT: String,
 * LEMLIST: String,
 * KLENTY: String,
 * APOLLO: String,
 * OUTREACH: String,
 * CONSTANT_CONTACT: String,
 * SENDGRID: String,
 * OUTPLAY: String,
 * ORTTO: String,
 * CONVERTKIT: String,
 * REPLY_IO: String
 * }}
 */
const EmailToolMergeFields = Object.freeze({
	[EmailTools.MAILCHIMP]: '*|EMAIL|*',
	[EmailTools.SENDINBLUE]: '{{contact.EMAIL}}',
	[EmailTools.ACTIVECAMPAIGN]: '%EMAIL%',
	[EmailTools.KLAVIYO]: '{{ email|default:"" }}',
	[EmailTools.PIPEDRIVE_CAMPAIGNS]: '*|EMAIL|*',
	[EmailTools.DRIP]: '{{ subscriber.email }}',
	[EmailTools.MAILERLITE]: '{$email}',
	[EmailTools.HUBSPOT]: '{{contact.email}}',
	[EmailTools.LEMLIST]: '{{email}}',
	[EmailTools.KLENTY]: '{{Email}}',
	[EmailTools.APOLLO]: '{{email}}',
	[EmailTools.OUTREACH]: '{{email}}',
	[EmailTools.CONSTANT_CONTACT]: '[[emailAddress]]',
	[EmailTools.SENDGRID]: '{{email}}',
	[EmailTools.OUTPLAY]: '{{emailid}}',
	[EmailTools.ORTTO]: '{{ people.email }}',
	[EmailTools.CONVERTKIT]: '{{ subscriber.email_address }}',
	[EmailTools.REPLY_IO]: '{{Email}}'
});

/**
 * @constant {{
 * MAILCHIMP: String,
 * SENDINBLUE: String,
 * ACTIVECAMPAIGN: String,
 * KLAVIYO: String,
 * PIPEDRIVE_CAMPAIGNS: String,
 * DRIP: String,
 * MAILERLITE: String,
 * HUBSPOT: String,
 * LEMLIST: String,
 * KLENTY: String,
 * APOLLO: String,
 * OUTREACH: String,
 * CONSTANT_CONTACT: String,
 * SENDGRID: String,
 * OUTPLAY: String,
 * ORTTO: String,
 * CONVERTKIT: String,
 * REPLY_IO: String
 * }}
 */
const EmailToolLabels = Object.freeze({
	[EmailTools.MAILCHIMP]: 'Mailchimp',
	[EmailTools.SENDINBLUE]: 'Brevo',
	[EmailTools.ACTIVECAMPAIGN]: 'ActiveCampaign',
	[EmailTools.KLAVIYO]: 'Klaviyo',
	[EmailTools.PIPEDRIVE_CAMPAIGNS]: 'Pipedrive Campaigns',
	[EmailTools.DRIP]: 'Drip',
	[EmailTools.MAILERLITE]: 'MailerLite',
	[EmailTools.HUBSPOT]: 'Hubspot',
	[EmailTools.LEMLIST]: 'Lemlist',
	[EmailTools.KLENTY]: 'Klenty',
	[EmailTools.APOLLO]: 'Apollo',
	[EmailTools.OUTREACH]: 'Outreach',
	[EmailTools.CONSTANT_CONTACT]: 'ConstantContact',
	[EmailTools.SENDGRID]: 'Sendgrid',
	[EmailTools.OUTPLAY]: 'Outplay',
	[EmailTools.ORTTO]: 'Ortto',
	[EmailTools.CONVERTKIT]: 'Convertkit',
	[EmailTools.REPLY_IO]: 'Reply.io',
	[EmailTools.GETRESPONSE]: 'GetResponse'
});

/**
 * @constant {{
 * UTM_SOURCE: String,
 * UTM_MEDIUM: String
 * }}
 * */
const UtmParameters = Object.freeze({
	UTM_SOURCE: 'utm_source',
	UTM_MEDIUM: 'utm_medium'
});

/**
 * @constant {String}
 * */
const OUTFUNNEL_EMAIL_PARAM = 'of_tpem';

export {
	EmailTools,
	EmailToolMergeFields,
	UtmParameters,
	OUTFUNNEL_EMAIL_PARAM,
	EmailToolLabels
};
